// install.js
import szxhBigscreen from "./views/index.vue";

export default {
    install: (Vue) => {
        Vue.component("szxh-bigscreen", szxhBigscreen)
    }
}